// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';


const config = {
    apiServer: 'https://cockpit.xn--stemmekbefysio-6ib.dk',
};

export default config